import IconAsMaskImage from '../IconAsMaskImage'

const BackIcon = ({ pureSvg, className, color, ...rest }) => {
  const svg = (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M15 19.5L8 12.5L15 5.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default BackIcon
